module.exports = __webpack_public_path__ + "img/file-earmark-ruled.f7ec4e58.svg";